<section class="our-origin section section__bg-gradient-parent">
  <div class="our-origin__gradient section__bg-gradient" aria-hidden="true"></div>

  <div class="our-origin__inner container">
    <div class="our-origin__content" appScrollReveal>
      <h2 class="our-origin__title title">Our Origin</h2>

      <div class="our-origin__story subheading-dark">
        @for (paragraph of storyParagraphs; track $index) {
          <p appScrollRevealItem>{{ paragraph }}</p>
        }
      </div>

      <div appScrollRevealItem class="our-origin__signature subheading-dark">
        @for (line of signatureLines; track $index) {
          <p>{{ line }}</p>
        }
      </div>
    </div>
  </div>
</section>
